<template>
  <div class="px-4 sm:px-6 py-5 space-y-8">
    <div class="space-y-6 sm:space-y-5">
      <div>
        <h3 class="text-lg leading-6 font-medium text-gray-900">Recipients</h3>
        <p class="mt-1 max-w-2xl text-sm text-gray-500">
          Below list contains all of your contacts that are subscribed and have at least one
          subscribed email address. Add conditions to further filter your final list.
        </p>
      </div>

      <div class="space-y-8">
        <RecipientList
          :account-id="emailCampaign.account_id"
          :query-filter="emailCampaignData.filter"
          @update-filter="emailCampaignData.filter = $event"
          :disabled="!canUpdate"
        />

        <BaseVeeForm :action="updateEmailCampaign">
          <template #default="formProps">
            <BaseFormTextFieldWithValidator
              v-bind="filterFieldProps"
              :disabled="!canUpdate || formProps.isPending"
            />

            <BaseButton primary :disabled="!canUpdate || formProps.isPending || formProps.ivalid">
              Save
            </BaseButton>
          </template>
        </BaseVeeForm>
      </div>
    </div>
  </div>
</template>

<script>
import RecipientList from './RecipientList.vue';

export default {
  components: {
    RecipientList,
  },
  props: {
    emailCampaign: {
      type: Object,
      required: true,
    },
    canUpdate: Boolean,
    onUpdate: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      emailCampaignData: {
        filter: Array.isArray(this.emailCampaign.filter || []) ? {} : this.emailCampaign.filter,
      },
    };
  },
  computed: {
    filterFieldProps() {
      return {
        value: JSON.stringify(this.emailCampaignData.filter),
        validator: {
          vid: 'filter',
          name: 'filter',
          rules: {
            required: true,
          },
        },
        field: {
          id: 'email_campaign_filter',
          inputType: 'hidden',
        },
      };
    },
  },
  methods: {
    updateEmailCampaign() {
      return this.onUpdate(this.emailCampaignData);
    },
  },
};
</script>
